import { apiClient } from "../../../base/ApiClient";

export const fetchEmailConversations = async () => {
  const response = await apiClient.get('/communications/email-conversations/');
  return response.data;
};

export const fetchEmailHistory = async (email, limit = 10) => {
  const response = await apiClient.get(`/communications/email-history/`, {
    params: { email, limit }
  });
  return response.data;
};

export const fetchGroupEmailHistory = async (limit = 10) => {
  const response = await apiClient.get(`/communications/group-email-history/`, {
    params: { limit }
  });
  return response.data;
};

export const sendEmail = async (payload) => {
  const response = await apiClient.post('/communications/send-email/', payload);
  return response.data;
};

export const sendGroupEmail = async (payload) => {
  const response = await apiClient.post('/communications/send-group-email/', payload);
  return response.data;
};